import Head from "next/head";
import { make as TeamBuilderPage } from "../../src/team-planner-core/TeamPlannerPage.bs";
import { lastPatch } from "common/src/Config.ts";

export default function TeamBuilder({ exalteds, locale }) {
  return (
    <>
      <Head>
        <title>TFT Team Comp Builder - Set 13</title>
      </Head>
      <TeamBuilderPage exalteds={exalteds} locale={locale} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const exaltedsResp = await fetch(
    `https://ap.tft.tools/static/s11/exalteds.json`,
  );
  const exalteds = await exaltedsResp.json();

  return {
    props: {
      exalteds,
      locale,
    },
  };
}
